
					const modules = import.meta.glob([
  "/src/mock/app.ts",
  "/src/mock/config_interface.ts",
  "/src/mock/finance_employeeSettelment.ts",
  "/src/mock/finance_employeesFinanceLogs.ts",
  "/src/mock/finance_financeLogs.ts",
  "/src/mock/finance_memberFinanceLogs.ts",
  "/src/mock/finance_memberSettlement.ts",
  "/src/mock/finance_mybills.ts",
  "/src/mock/member_memberGroup.ts",
  "/src/mock/member_memberLevel.ts",
  "/src/mock/member_memberList.ts",
  "/src/mock/organization_department.ts",
  "/src/mock/organization_employees.ts",
  "/src/mock/organization_role.ts",
  "/src/mock/project_surveyList.ts",
  "/src/mock/project_surveyRecord.ts",
  "/src/mock/project_terminatingRecord.ts",
  "/src/mock/user.ts"
], { eager: true });
					const fakeModuleList = Object.keys(modules).reduce((list, key) => {
						const module = modules[key] ?? {};
						if (module.default) {
							for (const moduleKey of Object.keys(module)) {
								const mod = modules[key][moduleKey] ?? [];
								const modList = Array.isArray(mod) ? [...mod] : [mod];
								return [...list, ...modList];
							}
						} else {
							return list;
						}
					}, []);
					window.__VITE__PLUGIN__FAKE__SERVER__.fakeModuleList = fakeModuleList;
				